import { Component, Inject, inject } from '@angular/core';
import { FocusedDeliverableId } from '../../models';
import { DATA_SELECTOR_INJECTION_TOKEN, DialogSize } from '@aiwyn/shared';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface DeletedDeliverableDialogData {
  deliverableId: FocusedDeliverableId;
}

@Component({
  selector: 'app-deleted-deliverable-dialog',
  templateUrl: './deleted-deliverable-dialog.component.html',
  styleUrls: ['./deleted-deliverable-dialog.component.scss'],
  providers: [
    {
      provide: DATA_SELECTOR_INJECTION_TOKEN,
      useValue: 'deleted-deliverable-dialog',
    },
  ],
  standalone: false,
})
export class DeletedDeliverableDialogComponent {
  public dataSelector = inject(DATA_SELECTOR_INJECTION_TOKEN);

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DeletedDeliverableDialogData,
  ) {}

  readonly DialogSize = DialogSize;
}
